import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';

/**
 * Assigns and unassigns Vehicle Groups to a Specific Speed Coaching Profile
 * @param id The ID of the Speed Coaching Profile being used for assignment
 * @param assignmentVehicleGroupIds The IDs of the Vehicle Groups being assigned
 * @param unassignmentVehicleGroupIds The IDs of the Vehicle Groups being unassigned
 * @returns Data object containing array of unassigned Vehicle Group's IDs
 */
export function postSpeedCoachingVehicleGroupsCombinedAssignment(
  this: unknown,
  id: number,
  assignmentVehicleGroupIds: number[],
  unassignmentVehicleGroupIds: number[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment
          .resolve(this)
          .speedCoachingVehicleGroupsCombinedAssignmentUrl(String(id)),
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({
            assignmentVehicleGroupIds,
            unassignmentVehicleGroupIds,
          }),
        }
      )
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: z.object({
          assigned: z.array(z.number()),
          unassigned: z.array(z.number()),
        }),
      })
    )
  );
}
